export const IS_CLEANING_APOLLO_CACHE = "IS_CLEANING_APOLLO_CACHE";
